import React from 'react';
import FileSaver from 'file-saver';
import { Button } from 'selfly-ui-react';

const DownloadFileButton = ({ label, className, filename, getBlob, unicode }) => {
    return (
        <Button className={className} onClick={() => FileSaver.saveAs(getBlob(), filename, { autoBom: unicode ? true : false })}>
            {label}
        </Button>
    );
};

export default DownloadFileButton;
